import { render } from "./SalesReportPage.vue?vue&type=template&id=51463562&scoped=true&ts=true"
import script from "./SalesReportPage.vue?vue&type=script&lang=ts"
export * from "./SalesReportPage.vue?vue&type=script&lang=ts"

import "./SalesReportPage.vue?vue&type=style&index=0&id=51463562&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51463562"]])

export default __exports__